{
  "RESET_PASSWORD": {
    "TITLE": "Passwort zurücksetzen",
    "DESCRIPTION": "Geben Sie die E-Mail-Adresse ein, mit der Sie sich beim Kontaktcenter anmelden, um die Anweisungen zum Zurücksetzen des Passworts zu erhalten.",
    "GO_BACK_TO_LOGIN": "Wenn Sie zur Login-Seite zurückkehren möchten",
    "EMAIL": {
      "LABEL": "E-Mail",
      "PLACEHOLDER": "Bitte geben Sie Ihre E-Mail ein.",
      "ERROR": "Bitte geben Sie eine gültige Email-Adresse ein."
    },
    "API": {
      "SUCCESS_MESSAGE": "Der Link zum Zurücksetzen des Passworts wurde an Ihre E-Mail gesendet.",
      "ERROR_MESSAGE": "Es konnte keine Verbindung zum Woot Server hergestellt werden. Bitte versuchen Sie es später erneut"
    },
    "SUBMIT": "Einreichen"
  }
}
